import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

import Meta from 'Components/Utility/SEO/Meta';
import NoIndex from 'Components/Utility/SEO/NoIndex';
import { supportUrl } from 'Config/lang';

const messages = defineMessages({
  title: {
    id: 'emailchangeconfirm.title',
    defaultMessage: 'Change Of Email Confirm',
  },
});

const EmailChangeConfirm = ({ emailChangeConfirm, match, confirm }) => {
  const { token } = match.params;
  const { formatMessage } = useIntl();

  useEffect(() => {
    emailChangeConfirm(token);
  }, [token, emailChangeConfirm]);

  return (
    <React.Fragment>
      <Meta brandTitle title={formatMessage(messages.title)} />
      <NoIndex />
      <div className="fanatical-general-page">
        <div className="container">
          <div className="fanatical-general-page-content">
            <h1>
              <FormattedMessage id="email-change-confirm.changeconfirm.title" defaultMessage="Confirm Change Email Address" />
            </h1>
            <hr />
            {confirm.status === 99 &&
            <p>
              <FormattedMessage
                id="email-change-confirm.confirm-change"
                defaultMessage="Thank you for confirming the change to your email address. Your account has been confirmed."
              />
            </p>
              }
            {confirm.status !== 0 && confirm.status !== 99 &&
            <React.Fragment>
              <p>
                <FormattedMessage
                  id="email-change-confirm.change-error"
                  defaultMessage="There has been an error changing your email address - {error}."
                  values={{
                    error: <span className="highlight-text">{confirm.error}</span>,
                  }}
                />
              </p>

              <div className="cta-group-container mt-4">
                <div className="cta-container">
                  <a
                    href={`${supportUrl()}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary"
                  >
                    <FormattedMessage id="email-change-confirm.support.button" defaultMessage="Go to the Support Centre" />
                  </a>
                </div>
              </div>
            </React.Fragment>
              }
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

EmailChangeConfirm.propTypes = {
  emailChangeConfirm: PropTypes.func.isRequired,
  confirm: PropTypes.shape({
    error: PropTypes.string,
    status: PropTypes.number,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      token: PropTypes.string,
    }),
  }),
};

EmailChangeConfirm.defaultProps = {
  confirm: {
    error: '',
    status: 0,
  },
  match: ({
    params: {
      token: '',
    },
  }),
};

export default EmailChangeConfirm;
